import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

export const CATEGORIES = [
  { value: 'tutoring', label: 'Tutoring', color: '#3A86FF' },
  { value: 'yard-work', label: 'Yard Work', color: '#2EC4B6' },
  { value: 'community', label: 'Community', color: '#6C63FF' },
  { value: 'tech', label: 'Tech Help', color: '#8B5CF6' },
  { value: 'pet-care', label: 'Pet Care', color: '#FF9F1C' },
  { value: 'event', label: 'Events', color: '#EC4899' },
  { value: 'environment', label: 'Environment', color: '#10B981' },
  { value: 'elderly', label: 'Elderly Care', color: '#F59E0B' },
  { value: 'food-bank', label: 'Food Bank', color: '#EF4444' },
  { value: 'other', label: 'Other', color: '#6B7280' },
];

export const getCategoryColor = (category) => {
  const cat = CATEGORIES.find(c => c.value === category);
  return cat ? cat.color : '#6B7280';
};

export const getCategoryLabel = (category) => {
  const cat = CATEGORIES.find(c => c.value === category);
  return cat ? cat.label : 'Other';
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const timeAgo = (dateStr) => {
  if (!dateStr) return '';
  const now = new Date();
  const d = new Date(dateStr);
  const diff = Math.floor((now - d) / 1000);
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
  return formatDate(dateStr);
};
